import './css/style.css';
import $ from 'jquery';
import 'jquery.cookie';
import { queryTemp, fetchDocuments, isJumped, isALLSelected, fetchResultPageDocuments, fetchQueryAZDocuments, languageFilters, productFilters, searchFilters, requestType } from "./commons";
let queryParams = {
    terumo_ifu_brandName_agg: '',
    terumo_ifu_productCodes: '',
    terumo_ifu_brandName_or_productCodes_ILIKE: ''
};

$(document).ready(function () {
    $('#slidershowResult').css("visibility", "visible");
    //disclaimerInit();
    $("#common-header").load("./components/header.html", function () {
        externelListener();
    });
    $("#common-footer").load("./components/footer.html");
    if (getCookie("website") != "Labeling") {
        //location.href = "index.html";
    }

    //var languages_part = document.getElementById('languages_part');
    var category_part = document.getElementById('category_part');
    var RAZcButtonList = document.getElementById('RAZcButtonList');
    var searchCode = document.getElementById('searchCode');
    //var inputBoxId = document.getElementById('RproductNameCode');
    var searchCodeSP = document.getElementById('searchCodeSP');

    var fullText;
    var url = window.location.search.substr(1).split("&");
    var decodedUrl = decodeURIComponent(url);
    var replaceUrl;
    isJumped.push(true);
    if (decodedUrl.startsWith('lanCategory')) {

        category_part.style.display = 'block';
        RAZcButtonList.style.display = 'none';
        if (searchCode != null)
            searchCode.style.visibility = 'hidden';
        if (searchCodeSP != null)
            searchCodeSP.style.visibility = 'hidden';

        replaceUrl = decodedUrl.replace(/=on/gi, "");
        replaceUrl = replaceUrl.replaceAll("+", " ");
        if (replaceUrl.indexOf(',') != -1) {
            fullText = replaceUrl.split(',');
        }
        // Language, Category検索処理を追加する。
        // isALLSelectedの処理をここに移動
        if (fullText.length > 1) {
            for (var i = 1; i < fullText.length; i++) {
                if (fullText[i] == "SallLcbox") {
                    isALLSelected.push(true);
                } else {
                    if (fullText[i].length >= 4) {
                        productFilters.push(fullText[i]);
                    } else {
                        languageFilters.push(fullText[i]);
                    }
                }
            }
            //    setCookie("language_clicked",languageFilters);
            //    setCookie("category_clicked",productFilters);
            $("#RTSearchResultWord").text('Search Result "Language and Products"');
            requestType.push("lanCategory");
            fetchResultPageDocuments(queryParams);
            return;
        }
    } else if (decodedUrl.startsWith('SBrandNProductC') || decodedUrl.startsWith('RproductNameCode') || decodedUrl.startsWith('RproductNameCodeNav')) {

        category_part.style.display = 'none';
        RAZcButtonList.style.display = 'none';
        if (searchCode != null)
            searchCode.style.visibility = 'block';
        if (searchCodeSP != null)
            searchCodeSP.style.visibility = 'block';


        replaceUrl = decodedUrl.replace(/=/gi, ",");
        replaceUrl = replaceUrl.replaceAll("+", " ");
        if (replaceUrl.indexOf(',') != -1) {
            fullText = replaceUrl.split(',');
        }
        var endFullText = fullText[1].replaceAll("\\", "\\\\");
        endFullText = endFullText.replaceAll(" ", "\\ ");
        var pattern = '+-=&|><!(){}[]^"~*?:/';
        //+-=&|><!(){}[]^"~*?:\/
        for (var j = 0; j < pattern.length; j++) {
            endFullText = endFullText.replaceAll(pattern[j], "\\" + pattern[j]);
        }
        if (fullText[1].length > 0)
            queryTemp.push(fullText[1]);
        // while (temp.length > 0){
        //     var search_element = temp.pop();
        //     if (search_element.length > 0)
        //         queryTemp.push(search_element); 
        // }

        if (isEmpty(endFullText)) {
            return false;
        }

        queryParams.terumo_ifu_brandName_or_productCodes_ILIKE = "*" + endFullText + "*";
        //input into search
        if (searchFilters.length > 0)
            searchFilters.pop();
        searchFilters.push(queryParams.terumo_ifu_brandName_or_productCodes_ILIKE);

        $("#RTSearchResultWord").text('Search Result  "' + fullText[1] + '"');
        const RproductNameCode = $("#RproductNameCode");
        RproductNameCode.val(fullText[1]);
        const RproductNameCodeNav = $("#RproductNameCodeNav");
        RproductNameCodeNav.val(fullText[1]);
        requestType.push("keyWordSearch");
        fetchDocuments(queryParams);
        return;
    } else if (decodedUrl.startsWith('FTproductsAZ')) {

        category_part.style.display = 'none';
        RAZcButtonList.style.display = 'block';
        if (searchCode != null)
            searchCode.style.visibility = 'hidden';
        if (searchCodeSP != null)
            searchCodeSP.style.visibility = 'hidden';
        queryParams = {};
        $("#RTSearchResultWord").text('Search Result "Brand name A-Z"');
        $("#resultBigTitle").text('Brand name A-Z');
        requestType.push("AZSearch");
        fetchQueryAZDocuments(queryParams);
        return;
    }

    fetchDocuments(queryParams);

});

$("#RproductNameCodeNav").on("change keyup paste", function () {
    var currentVal = $(this).val();
    if (currentVal == "") {
        document.getElementById("navResultBtnCheck").disabled = true;
    } else {
        document.getElementById("navResultBtnCheck").disabled = false;
    }
});

$("#RproductNameCode").on("change keyup paste", function () {
    var currentVal = $(this).val();
    if (currentVal == "") {
        document.getElementById("resultBtnCheck").disabled = true;
    } else {
        document.getElementById("resultBtnCheck").disabled = false;
    }
});

$('.btnBack').click(function () {
    //window.open('about:blank','_self').close();
    window.history.back();
});

$('#resultBtn').click(function () {
    var tmp = $("#RproductNameCode").val();
    if (isEmpty(tmp)) {
        return;
    } else {
        var $form = $('form[name="resultForm"]');
        $form.submit();
    }
})

$('#navResultBtn').click(function () {
    var tmp = $("#RproductNameCodeNav").val();
    if (isEmpty(tmp)) {
        return;
    } else {
        var $form = $('form[name="navResultForm"]');
        $form.submit();
    }
})

var linkName = "";
$('#HDterumoGlobal').click(function (e) {
    $(".module-sticky-footer").show();
    $(".popupLeave").show();
    linkName = e.target.id;
})

$('#HDcontact').click(function (e) {
    $(".module-sticky-footer").show();
    $(".popupLeave").show();
    linkName = e.target.id;
})

$('#FTcontact').click(function (e) {
    $(".module-sticky-footer").show();
    $(".popupLeave").show();
    linkName = e.target.id;
})

$('.cancelActionLeave').click(function () {
    $(".module-sticky-footer").hide();
    $(".popupLeave").hide();
});

$('.doActionLeave').click(function () {
    $(".module-sticky-footer").hide();
    $(".popupLeave").hide();
    if (linkName == "HDterumoGlobal") {
        location.href = "https://www.terumo.com/";
    } else {
        location.href = "https://www.terumo-europe.com/en-emea/contact";
    }
});

String.prototype.replaceAll = function (org, dest) {
    return this.split(org).join(dest);
}

function getCookie(name) {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
}

function isEmpty(str) {
    if (typeof str == "undefined" || str == null || str == "")
        return true;
    else
        return false;
}

$(document).on('click', 'nav .tit', function () {
    if ($(this).hasClass('close')) {
        $(this).removeClass('close');
        $(this).next().slideDown('normal', function () { });
    } else {
        $(this).addClass('close');
        $(this).next().slideUp('normal', function () { });
    }
    return false;
});

/////////////////
var scrollTop = 0;
$(document).on('click', 'nav .navTit .btnClose', function () {
    $('nav').css({
        opacity: 1
    }).animate({
        opacity: 0
    }, 'normal', function () {
        $('html').removeClass('navOpen');
        $('html,body').scrollTop(scrollTop);
        scrollTop = 0;
        $('body').css({
            top: 0
        });
    });
    return false;
});
$('.btnFilter a').on('click', function () {
    if ($('html').hasClass('navOpen')) {
        $('html').removeClass('navOpen');
    } else {
        scrollTop = $('html,body').scrollTop();
        $('body').css({
            top: scrollTop * -1
        });
        $('html').addClass('navOpen');

        $('nav').css({
            opacity: 0
        }).animate({
            opacity: 1
        });
    }
    return false;
});

//////////////
$(document).on('click', 'header .headerInr .menu', function () {

    var $nav = $('header .headerInr .nav');

    if ($('html').hasClass('menuOpen')) {
        $nav.css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('menuOpen');
            $('html,body').scrollTop(scrollTop);
            scrollTop = 0;
            $nav.css({
                opacity: 1
            });
        });
    } else {
        scrollTop = $('html,body').scrollTop();
        $('html').addClass('menuOpen');
        $nav.css({
            top: $('header').outerHeight(),
            opacity: 0
        }).animate({
            opacity: 1
        });
    }
    return false;
});
/////////////
$('.resultHead .result dl dd').on('click', function () {
    if ($('header .headerInr .menu').css('display') === 'none') return false;
    var $next = $(this);
    $next.css({
        opacity: 1
    }).animate({
        opacity: 0
    }, 'normal', function () {
        $('html').removeClass('helpOpen');
        $next.removeClass('open');
        $('html,body').scrollTop(scrollTop);
        $('body').css({
            top: 0
        });
        scrollTop = 0;
    });

    return false;
});
$('.resultHead .result dl dt').on('click', function () {
    if ($('header .headerInr .menu').css('display') === 'none') return false;
    var $next = $(this).next();

    if ($('html').hasClass('helpOpen')) {
        $next.css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('helpOpen');
            $next.removeClass('open');
            $('html,body').scrollTop(scrollTop);
            $('body').css({
                top: 0
            });
            scrollTop = 0;
        });
    } else {
        scrollTop = $('html,body').scrollTop();
        $next.addClass('open');
        $('html').addClass('helpOpen');
        $('body').css({
            top: scrollTop * -1
        });

        $next.css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });
    }
    return false;
});
//////外部サイト移動告知
function externelListener() {
    var href;
    var externalclose = function () {
        $('#external').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $(this).css({
                opacity: 1
            });
            $('html').removeClass('externalOpen');
        });
    };
    $('#external button.yes').on('click', function () {
        window.open(href, 'blank');
        externalclose();
        return false;
    });
    $('#external button.no').on('click', function () {
        externalclose();
        return false;
    });
    $('a[target="_blank"]').on('click', function () {
        href = $(this).attr('href');

        $('html').addClass('externalOpen');

        $('#external').css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });

        return false;
    });
}

//////Cookie承認
function cookieLayerInit() {
    var cookieLayerclose = function () {
        $('#cookieLayer').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $(this).css({
                opacity: 1
            });
            $('html').removeClass('cookieLayerOpen');
        });
        $('[data-role="policy"] .btnOk').hide();
    };

    var cookieOk = function () {
        $.cookie('cookieaccepted', 'true', { expires: 1, path: '/' });
        cookieLayerclose();
    };
    $('#cookieLayer button.yes').on('click', function () {
        cookieOk();
        disclaimerInit();
        return false;
    });

    // $('[data-role="policy"] .btnOk').on('click',function () {
    //     cookieOk();
    //     return false;
    // });

    // $('#cookieLayer a.gotoPolicy').on('click',function () {
    //     window.location.href = $(this).attr('href');
    //     showPolicy();
    //     return false;
    // });

    if ($.cookie('cookieaccepted') === undefined) {
        $('html').addClass('cookieLayerOpen');

        $('#cookieLayer').css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });
    } else {
        // $('[data-role="policy"] .btnOk').hide();
        disclaimerInit();
    }
}

//////閲覧者確認
function professionalInit() {
    var professionalclose = function () {
        $('#professional').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $(this).css({
                opacity: 1
            });
            $('html').removeClass('professionalOpen');
        });
    };
    $('#professional button.yes').on('click', function () {
        $.cookie('hcppolicy', 'accepted', { expires: 1, path: '/' });
        professionalclose();
        // cookieLayerInit();
        return false;
    });
    $('#professional button.no').on('click', function () {
        $.cookie('hcppolicy', 'denied', { expires: 1, path: '/' });
        professionalclose();
        // cookieLayerInit();
        return false;
    });

    if ($.cookie('hcppolicy') === undefined) {
        $('html').addClass('professionalOpen');

        $('#professional').css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });
    } else {
        // cookieLayerInit();
    }
}
/////免責画面
function disclaimerInit() {
    var disclaimerClose = function () {
        $('#disclaimer').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('disclaimerOpen');
        });
    };
    $('#disclaimer .disclaimer-cont ul li .btnContinue').on('click', function () {
        disclaimerClose();
        $.cookie('disclaimer', 'true', { expires: 1, path: '/' });
        professionalInit();
        return false;
    });
    $('#disclaimer .disclaimer-cont ul li .btnBack').on('click', function () {
        console.log(document.referrer);
        if (window.opener) {
            window.close();
        } else if (document.referrer) {
            window.location.href = document.referrer;
        }
        return false;
    });

    if ($.cookie('disclaimer') === undefined) {
        $('html').addClass('disclaimerOpen');
        $('#disclaimer').css({
            opacity: 0
        }).animate({
            opacity: 1
        });
    } else {
        professionalInit();
    }
}
if ($('#cookieLayer')[0]) {
    cookieLayerInit();
} else if ($('#disclaimer')[0]) {
    disclaimerInit();
}
////////////////
(function () {
    $('.readMore').on('click', function () {
        var $parent = $(this).parent();
        if ($parent.hasClass('open')) {
            $parent.find('.storage').slideUp();
            $parent.removeClass('open');
            var top = $parent.offset().top;
            $('html,body').animate({
                scrollTop: top
            });
        } else {
            $parent.find('.storage').slideDown();
            $parent.addClass('open');
        }
        return false;
    });
})();
////トップリサイズ
var ontopresize = function () {
    var _display = $('header .headerInr .menu').css('display');
    if (_display === 'none') {
        var len = $('ul.vertical.products li').length;
        var col = Math.ceil(len / 3);
        var ht = 0;
        $('ul.vertical.products li').each(function () {
            if (ht < $(this).outerHeight()) {
                ht = $(this).outerHeight();
            }
        });
        $('ul.vertical.products').css({
            height: ht * col
        });
    } else {
        $('ul.vertical.products').css({
            height: ''
        });
    }
};
if ($('ul.vertical.products')[0]) {
    $(window).on('resize.products', ontopresize);
    ontopresize();
}
////検索結果リサイズ
var onresultresize = function () {
    var _display = $('header .headerInr .menu').css('display');
    if (_display === 'none') {
        $('.resultList .item .itemHead').each(function () {
            var $itemHead = $(this);
            var ht = 0;
            $itemHead.find('td').each(function () {
                var oh = $(this).outerHeight();
                if (ht < oh) ht = oh;
            });

            $itemHead.find('td').css({
                height: ht
            });
        });

    }
};
if ($('.resultList .item .itemHead')[0]) {
    $(window).on('resize.result', onresultresize);
    onresultresize();
}

String.prototype.startsWith = function (str) {
    if (this.length < str.length) { return false; }
    return this.indexOf(str) == 0;
}

